// extracted by mini-css-extract-plugin
export default {"primaryButtons":"EditPhotoPointPhotos_primaryButtons__wPTZS","photosDiv":"EditPhotoPointPhotos_photosDiv__qC1kG","photos":"EditPhotoPointPhotos_photos__2CQB2"};